// extracted by mini-css-extract-plugin
export default {"common":"\"../../styles/common.css\"","box":"common_box__y4kFQ","container":"styles_container__efRRp common_box__y4kFQ"};